module.exports = __webpack_public_path__ + "img/contacto_16-9_1440.965b30ab.jpg";